import React from 'react';
import { shape, string, node, number, bool } from 'prop-types';
import { getPrimaryIndustryNameById } from '@paddl/utils-js';
import { LogoCardWithText, MarkDownSection } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
import { getActivityDetailsBulletPoints } from '../../../../Utils/activities';
export const SideHustleRead = _ref => {
  let {
    data: {
      details: {
        role: {
          name: roleName
        },
        workingLocation: {
          originalText: workingLocation
        },
        employer: {
          icon: employerIcon,
          name: employerName
        },
        description,
        hoursPerWeek,
        primaryIndustryId,
        motivation
      }
    },
    editButton
  } = _ref;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, roleName), /*#__PURE__*/React.createElement(LogoCardWithText, {
    avatarUrl: employerIcon,
    title: employerName,
    subtitle: workingLocation,
    isSubtitleShortened: true
  }), description ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(MarkDownSection, {
    markDown: description
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, getActivityDetailsBulletPoints(motivation)), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(getPrimaryIndustryNameById(primaryIndustryId), " \u2022\n        ").concat(hoursPerWeek, " Hours / Week")));
};
SideHustleRead.propTypes = {
  data: shape({
    details: shape({
      role: shape({
        name: string
      }),
      workingLocation: shape({
        originalText: string
      }),
      employer: shape({
        icon: string,
        name: string
      }),
      description: string,
      hoursPerWeek: number,
      primaryIndustryId: number,
      motivation: shape({
        passion: bool,
        income: bool,
        learning: bool,
        fun: bool
      })
    }).isRequired
  }).isRequired,
  editButton: node
};
SideHustleRead.defaultProps = {
  editButton: undefined
};